<template>
    <div class="page-container year-on-year-analysis-container">
        <me-collapes @collapesCb="collapesCb" :treeTitle="'采集点选择'" :style="`width:calc(${treeOuterWidth}px + 40px)`">
            <div class="tree-container" :style="`width:calc(${treeOuterWidth}px + 40px)`">
                <me-tree
                    ref="myTree"
                    :treeData="treeData"
                    :treeLoading="treeLoading"
                    :treeToolBar="false"
                    :defaultProps="defaultProps"
                    :nodeKey="'point_id'"
                    :showCheckbox="true"
                    :title="'采集点选择'"
                    :isSingle="true"
                    :defaultExpandAll="true"
                    :defaultCheckKeys="defaultCheckKeys"
                    :checkStrictly.sync="checkStrictly"
                    :defaultExpandedKeys="defaultExpandedKeys"
                    @handleCheckBoxClick="handleTreeNodeClick"
                    @handleStretchClick="handleStretchClick"
                ></me-tree>
            </div>
        </me-collapes>
        <div class="echart-container" :style="`width:calc(100% - ${treeOuterWidth}px - 40px)`">
            <el-scrollbar style="height: 100%; width: 100%;">
                <div
                    style="text-align: left; font-size: 16px; border-left:5px solid #56fcff; padding-left: 10px; color: #fff; margin-bottom: 20px;"
                >同比分析趋势图</div>
                <v-chart :auto-resize="true" :options="bar" ref="bar" theme="ovilia-green" />

                <div
                    style="text-align: left; font-size: 16px; border-left:5px solid #56fcff; padding-left: 10px; color: #fff; margin-bottom: 20px;"
                >同比分析数据</div>
                <div class="table-wrap">
                    <el-table
                        border
                        :data="tableList"
                        highlight-current-row
                        class="leader-style-table"
                        style="width: 100%"
                    >
                        <el-table-column width="50" align="center" label="序号">
                            <template slot-scope="scope">
                                <span>{{ scope.$index + 1 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="月份" align="center" prop="year_month"></el-table-column>
                        <el-table-column label="本期" align="center" prop="active_power"></el-table-column>
                        <el-table-column label="同期" align="center" prop="active_power_ago"></el-table-column>
                        <el-table-column label="同比" align="center" prop="yoy_rate"></el-table-column>
                        <el-table-column label="累计同比" align="center" prop="yoy_all_rate"></el-table-column>
                    </el-table>
                </div>
            </el-scrollbar>
        </div>
    </div>
</template>
<script>
import Tree from "@/comon/components/tree.vue";
import Collapes from "@/comon/components/collapse-block.vue";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import * as api from "@/http/Use_electricity_monitor";
import { getYoyList } from "@/http/hr";
import utils from "@/utils/utils";
export default {
    components: {
        "me-tree": Tree,
        "me-collapes": Collapes
    },
    data() {
        return {
            treeOuterWidth: 280,
            treeData: [],
            checkStrictly: true,
            defaultProps: {
                children: "childList",
                label: "point_name"
            },
            treeSelect: {},
            defaultCheckKeys: [],
            select_point_id: "",
            tableList: [],
            xAxisData: [],
            active_power: [], //本期
            active_power_ago: [], //同期
            width: "calc(100% - 300px)"
        };
    },
    created() {
        this.getUnitPointList();
    },
    methods: {
        /**
         * 格式化tree disabled状态；
         */
        tickMenuIdFilter() {
            let resultArr = new Array();
            let firstPoint = new Object();
            let getTickMenuId = function (obj) {
                if (
                    undefined === obj ||
                    null === obj ||
                    !(obj instanceof Object)
                ) {
                    return;
                }
                if (obj.w_active == "0") {
                    //实采集点
                    obj.disabled = true;
                    resultArr.push(obj.id);
                } else {
                    obj.disabled = false;
                    //虚点
                    if (!firstPoint.point_id) {
                        firstPoint = obj;
                    }
                }

                if (null != obj.childList && obj.childList instanceof Array) {
                    for (let child of obj.childList) {
                        getTickMenuId(child);
                    }
                }
            };

            return {
                filter: function (arr) {
                    if (!(arr instanceof Array)) {
                        return false;
                    }
                    resultArr = new Array();
                    firstPoint = new Object();
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    return { tree: resultArr, firstPoint: firstPoint };
                }
            };
        },
        //获取采集点
        getUnitPointList() {
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            api.getUnitPointList({ point_class_id: "001" }).then(res => {
                if (res && res.error_code === "0") {
                    this.treeData = res.bus_json;

                    let formatData = this.tickMenuIdFilter().filter(
                        res.bus_json
                    );
                    this.defaultCheckKeys = [formatData.firstPoint.point_id];
                    // if (!this.treeSelect.point_id) {
                    //     this.$refs.myTree.handleNodeClick(res.bus_json[0]);
                    // } else {
                    //     this.$refs.myTree.handleNodeClick(
                    //         formatData.firstPoint
                    //     );
                    // }

                    this.getYoyList(
                        this.defaultCheckKeys && this.defaultCheckKeys[0]
                    );
                }
            });
        },
        handleTreeNodeClick(select) {
            this.defaultCheckKeys = [select.point_id];
            this.treeSelect = select;
            this.getYoyList(select.point_id);
        },
        handleStretchClick(treeOuterWidth) {
            this.treeOuterWidth = treeOuterWidth;
        },
        getYoyList(point_id) {
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            getYoyList({ point_id: point_id }).then(res => {
                if (res && res.error_code === "0") {
                    this.tableList = res.bus_json;
                    this.xAxisData = [];
                    this.active_power = [];
                    this.active_power_ago = [];
                    this.tableList.map(item => {
                        this.xAxisData.push(item.year_month);
                        this.active_power.push(item.active_power);
                        this.active_power_ago.push(item.active_power_ago);
                    });
                }
                loading.close();
            });
        },
        /**
         * 监听树结构收起展开
         */
        collapesCb(collapes) {
            this.width = collapes ? "calc(100% - 300px)" : "calc(100% - 61px)";
        }
    },
    computed: {
        bar() {
            const options = {
                grid: {
                    left: "3%",
                    right: "0%",
                    bottom: "5%",
                    top: "13%",
                    containLabel: true
                },

                title: {
                    text: "",
                    subtext: ""
                },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: ["本期", "同期"],
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                color: ["#0093ea", "#fe7f65"],
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: "月",
                        data: this.xAxisData,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "单位: kW·h",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "本期",
                        type: "bar",
                        barGap: 0,
                        barWidth: "30%",
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#06B4F9'
                                }, {
                                    offset: 1,
                                    color: '#092856'
                                }]),
                                barBorderRadius: [10, 10, 0, 0]
                            }
                        },
                        data: this.active_power
                    },
                    {
                        name: "同期",
                        type: "bar",
                        barGap: 0,
                        barWidth: "30%",
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#F97464'
                                }, {
                                    offset: 1,
                                    color: '#FB3737'
                                }]),
                                barBorderRadius: [10, 10, 0, 0]
                            }
                        },
                        data: this.active_power_ago
                    }
                ]
            };
            return options;
        }
    }
};
</script>
<style lang="scss">
.page-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    padding: 0 1rem 0 0;
    .el-card {
        background-color: transparent;
        border: 1px solid #56fcff;
    }
    .el-card__header {
        border-bottom: 1px solid #56fcff;
    }
    .el-table__fixed-right::before,
    .el-table__fixed::before {
        height: 0;
    }
    .collapes-block-container {
        margin-right: 0;
    }

    // .el-scrollbar__wrap {
    //     overflow: hidden;
    //     height: 100%;
    // }
    .tree-container {
     //   width: px2Rem(280px);
        height: 100%;
        overflow: hidden;
        box-sizing: border-box;
        border-radius: 5px;
    }
    .echart-container {
        width: calc(100% - 300px);
        margin-left: 20px;
        margin-right: 10px;
        margin-top: 5px;
        transition: width 500ms;
        overflow-y: auto;
        .echarts {
            width: 100%;
            height: 240px;
        }
    }
}
</style>
